











import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Question2, AnswerWithSubQuestions, FailureQuestion } from "@dsm/dsm-storybook";
import { namespace } from "vuex-class";

const advise = namespace("advise");

@Component({
  components: {
    FailureQuestion
  }
})

export default class QuestionView extends Vue {
  @Prop({type: Object}) question!: Question2;
  @Prop({type: String}) questionNumber!: string;

  onAnswer(answer: AnswerWithSubQuestions, question: Question2, parentQuestion: Question2 | null) {
    answer.isSelected = true;
    question.isActive = false;
    this.$emit("answer", answer, question, parentQuestion);
    this.onNext(answer, question, parentQuestion);
  }

  onNext(answer: AnswerWithSubQuestions, question: Question2, parentQuestion: Question2 | null) {
    if (answer.subQuestions.length > 0) {
      const index = answer.subQuestions.findIndex(item => item.i18nQuestion === question.i18nQuestion);
      const nextIndex = index == -1
        ? 0
        : index == answer.subQuestions.length - 1
          ? index
          : index + 1;
      answer.subQuestions[nextIndex].isActive = true;
    } else {
      this.$emit('completed')
    }
  }
}
